module.exports = __webpack_public_path__ + "img/icon_recenter.154913e4.svg";